(function () {
  if (!window.SBSWishlist) return;

  const cfg = window.SBSWishlist;
  const STORAGE_KEY = cfg.storageKey;

  let items = [];
  let resolveReady;
  const ready = new Promise((res) => { resolveReady = res; });

  const localBackend = {
    read() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) { return []; }
    },
    write(list) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
      catch (e) { console.warn('[wishlist] write failed', e); }
    }
  };

  const idOf = (raw) => String(raw);
  const has = (id) => items.some((it) => it.id === idOf(id));
  const getAll = () => items.slice();

  function persist() { localBackend.write(items); }
  function dispatchChanged() {
    document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { items: getAll() } }));
  }

  function add(item) {
    const id = idOf(item.id);
    if (has(id)) return;
    items.push({ id, handle: String(item.handle || '') });
    persist();
    dispatchChanged();
  }
  function remove(id) {
    const sid = idOf(id);
    const before = items.length;
    items = items.filter((it) => it.id !== sid);
    if (items.length !== before) { persist(); dispatchChanged(); }
  }
  function toggle(item) { has(item.id) ? remove(item.id) : add(item); }

  let liveRegion = null;
  function ensureLiveRegion() {
    if (liveRegion) return liveRegion;
    liveRegion = document.createElement('div');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;';
    document.body.appendChild(liveRegion);
    return liveRegion;
  }
  function announce(msg) {
    if (!msg) return;
    const region = ensureLiveRegion();
    region.textContent = '';
    setTimeout(() => { region.textContent = msg; }, 50);
  }

  function applyStateToButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const id = btn.getAttribute('data-product-id');
      const active = has(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      const labelAdd = btn.getAttribute('data-label-add');
      const labelRemove = btn.getAttribute('data-label-remove');
      if (labelAdd && labelRemove) {
        btn.setAttribute('aria-label', active ? labelRemove : labelAdd);
      }
    });
  }

  function handleClick(e) {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('data-product-id');
    const handle = btn.getAttribute('data-product-handle');
    if (!id) return;
    const willAdd = !has(id);
    toggle({ id, handle });
    const msg = willAdd ? btn.getAttribute('data-announce-add') : btn.getAttribute('data-announce-remove');
    announce(msg);
  }

  function handleStorage(e) {
    if (e.key !== STORAGE_KEY) return;
    items = localBackend.read();
    applyStateToButtons();
    dispatchChanged();
  }

  function init() {
    items = localBackend.read();
    applyStateToButtons();
    dispatchChanged();
    document.addEventListener('click', handleClick);
    window.addEventListener('storage', handleStorage);
    document.addEventListener('wishlist:changed', applyStateToButtons);
    resolveReady();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.SBSWishlist.api = { add, remove, toggle, has, getAll };
  window.SBSWishlist.ready = ready;
})();
